import {
  formatDateTimeIST,
  formatRouteStatusLabel,
} from "./routeTrackFormat";

/**
 * Plain-text route report for Share / clipboard / WhatsApp manual paste.
 * `data` is the API result from GET /api/route-track/daily-report.
 */
export function buildRouteDetailReportPlainText(data) {
  if (!data) return "";
  const esc = (x) => (x == null ? "" : String(x));
  const lines = [];
  lines.push("ROUTE DETAIL REPORT");
  lines.push(`Date: ${esc(data.date)}`);
  lines.push(`Employee: ${esc(data.employee_name)}`);
  lines.push(
    `Route status: ${esc(formatRouteStatusLabel(data.route_status))}`
  );
  lines.push("");
  const sum = data.summary || {};
  lines.push(
    `Summary — Total stops: ${sum.total ?? 0}, Visited: ${sum.visited ?? 0}, Not visited: ${sum.not_visited ?? 0}, Skipped: ${sum.skipped ?? 0}`
  );
  lines.push("");
  lines.push("Stops (visit order):");
  (data.stops || []).forEach((s) => {
    lines.push(
      `${s.sequence_no}. ${esc(s.display_name)} — ${esc(s.status_label || s.status)}`
    );
    if (s.address) lines.push(`   Address: ${esc(s.address)}`);
    if (s.status === "visited") {
      const whenRaw = s.actual_arrival_time || s.visited_at_display;
      if (whenRaw) {
        const when = formatDateTimeIST(whenRaw) || esc(whenRaw);
        lines.push(`   Visited at: ${esc(when)}`);
      }
    }
    if (s.notes) lines.push(`   Notes: ${esc(s.notes)}`);
  });
  return lines.join("\n").trim();
}
